import ContraCP from './../contraCP/ContraCP';
import ElementType from './../contraCP/types/elementType';
import MainShapeType from './../contraCP/types/mainShapeType';
import FontLoaderFonts from './../contraCP/types/fontLoaderFonts';
import configuratorHtml from './configurator.html';
import addToCartModalHtml from './addToCartModal.html';
import addToCartModalController from './addToCartModal.controller';
import mainShapeParams from './../mainShapeParams';
import CutModes from './../cutModes';
import ToastTemplate from './../toast/toast.html'
import Validator from './validator';
import clonedeep from 'lodash.clonedeep';
import priceTypeService from "../price/priceType.service";

class configuratorController {
    constructor($scope, $timeout, $interval, $state, $window, $mdToast, configuratorService, ModalService, $rootScope, translateService, priceTypeService, $sce) {
        'ngInject';

        // Globals
        this.$timeout = $timeout;
        this.$interval = $interval;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.$mdToast = $mdToast;
        this.modalService = ModalService;
        this.service = configuratorService;
        this.state = $state;
        this.translate = translateService;
        this.$sce = $sce;
        this.model = null;
        this.omitNextMainShapeWatch = false;
        this.omitNextMaterialSettingsWatch = false;

        // ContraCP params
        this.uniqueId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
        this.CPdimensions = {
            x: 765,
            y: 510
        };

        // Model data
        this.activeElement = null;
        this.elements = [];
        this.ElementType = ElementType;
        this.MainShapeType = MainShapeType;
        this.mainShapes = [];

        for (const type of MainShapeType) {
            if (!type.name) continue;

            let shape = {
                name: `configurator.mainShape.type.${type.name}`,
                type: type,
                available: true,
                image: `/assets/FE/js/configurator/images/main-shape/${type.name}.png`,
                imageMobile: `/assets/FE/js/configurator/images/main-shape/${type.name}.svg`,
                imageMobileActive: `/assets/FE/js/configurator/images/main-shape/${type.name}Active.svg`
            };

            this.mainShapes.push(shape);
        }

        this.activeMainShape = null;
        this.FontLoaderFonts = FontLoaderFonts;
        this.price = 0;
        this.priceType = priceTypeService;
        this.currency = {
            symbol: null,
            symbol_placement: null
        };
        this.quantity = 1;
        this.deliveryDate = null;
        this.shop_id = null;
        this.calculatingPrice = false;
        this.calculatingPriceTimeout = null;
        this.mainShapeParams = mainShapeParams;
        this.errors = [];
        this.materials = [];
        this.focusedParam = null;
        this.holes = [
            {
                name: `configurator.mainShape.type.${this.MainShapeType.Circle.name}`,
                shape: this.MainShapeType.Circle,
                image: `/assets/FE/js/configurator/images/main-shape/${this.MainShapeType.Circle.name}.png`,
                imageMobile: `/assets/FE/js/configurator/images/main-shape/${this.MainShapeType.Circle.name}.svg`,
                imageMobileButton: `/assets/FE/js/configurator/images/main-shape/${this.MainShapeType.Circle.name}White.svg`,
                info: 'configurator.holes.info.Circle' //'Pozycja otworu jest obliczana od lewego dolnego narożnika do środka otworu.'
            },
            {
                name: `configurator.mainShape.type.${this.MainShapeType.Rect.name}`,
                shape: this.MainShapeType.RoundedRect,
                image: `/assets/FE/js/configurator/images/main-shape/${this.MainShapeType.Rect.name}.png`,
                imageMobile: `/assets/FE/js/configurator/images/main-shape/${this.MainShapeType.Rect.name}.svg`,
                imageMobileButton: `/assets/FE/js/configurator/images/main-shape/${this.MainShapeType.Rect.name}White.svg`,
                info: 'configurator.holes.info.RoundedRect' //'Pozycja otworu jest obliczana od lewego dolnego narożnika do lewego dolnego narożnika otworu.'
            }
        ];

        this.availableHoleTypes = angular.copy(this.holes);
        this.activeMaterial = null;
        this.materialSettings = {
            type: null,
            subType: null,
            size: null
        };
        this.lastProperMainShapeModel = null;
        this.lastProperElementsModel = null;
        this.lastProperMaterialSettings = null;
        this.CPdimensionsTimeout = null;
        this.WindowSizeTimeout = null;
        this.loadedModelMaetrialSet = false;
        this.CPpadding = {
            desktop: 50, mobile: 35
        };

        this.cutModes = [
            {
                type: CutModes.chain,
                name: 'configurator.cutMode.chain.desktop',
                mobile_name: 'configurator.cutMode.chain.mobile',
                image: `/assets/FE/js/configurator/images/cut-modes/${CutModes.chain.name}.jpg`,
                available: true
            },
            {
                type: CutModes.laser,
                name: 'configurator.cutMode.laser.desktop',
                mobile_name: 'configurator.cutMode.laser.mobile',
                image: `/assets/FE/js/configurator/images/cut-modes/${CutModes.laser.name}.jpg`,
                available: true
            },
            {
                type: CutModes.chainPolished,
                name: 'configurator.cutMode.chainPolished.desktop',
                mobile_name: 'configurator.cutMode.chainPolished.mobile',
                image: `/assets/FE/js/configurator/images/cut-modes/${CutModes.chainPolished.name}.jpg`,
                available: true
            },
            {
                type: CutModes.frez,
                name: 'configurator.cutMode.frez.desktop',
                mobile_name: 'configurator.cutMode.frez.mobile',
                image: `/assets/FE/js/configurator/images/cut-modes/${CutModes.frez.name}.jpg`,
                available: true
            }
        ];
        this.activeCutMode = null;
        this.oldActiveCutMode = null;
        this.storedCutMode = null;
        this.availableMainShapeTypes = angular.copy(this.mainShapes);
        this.wantAddHoles = false;
        this.isReady = false;
        this.omitChangeMaterialUrl = false;
        this.urlParts = {};
        this.maximumTextHeight = 0;

        this.mainShape = {
            oldType: null,
            type: null,
            rawElement: null
        };

        this.$scope.paste = function(event) {
            let pastedData = '';

            if(typeof event.originalEvent.clipboardData !== "undefined"){
                pastedData = event.originalEvent.clipboardData.getData('text/plain');
            } else if(window.clipboardData){
                pastedData = window.clipboardData.getData('Text');
                event.returnValue = false;
            }

            if(/[^0-9]/.test(pastedData)) {
                event.preventDefault();
            }
        }
    }

    $postLink() {
        // Bindings ready
        if (this.$scope.elementWidth) {
            this.CPdimensions = {
                x: this.$scope.elementWidth,
                y: this.$scope.elementWidth / 1.5
            };
        }
        this.$timeout(() => {
            // View render end
            this.CP = new ContraCP(`#board-configurator-${this.uniqueId}`,
                this.CPdimensions.x,
                this.CPdimensions.y,
                0,
                this.isMobile ? this.CPpadding.mobile : this.CPpadding.desktop,
                this.translate);

            this.CPText = new ContraCP(`#text-configurator-${this.uniqueId}`,
                this.CPdimensions.x,
                this.CPdimensions.y,
                2,
                this.isMobile ? this.CPpadding.mobile : this.CPpadding.desktop,
                this.translate);

            this.CP.setMobile(this.isMobile);
            this.CPText.setMobile(this.isMobile);

            let onChangeTimeout = null;

            this.CP.onChange((rawElement) => {

                if (onChangeTimeout) {
                    this.$timeout.cancel(onChangeTimeout);
                    onChangeTimeout = null;
                }

                onChangeTimeout = this.$timeout(() => {
                    this.synchronizeModel();

                    let match = this.elements.filter(element => element.rawElement === rawElement)[0];

                    if (!match) return;

                    this.setActiveElement(match);

                    this.$scope.$apply();
                }, 100);

            });

            this.CP.onClick((rawElement) => {
                let match = this.elements.filter(element => element.rawElement === rawElement)[0];

                if (!match) return;

                this.setActiveElement(match);

                this.$scope.$apply();
            });

            let unbindElementsWatch = null;
            let omitNextElementsValidation = false;

            const revertWrongElementsChanges = (newVal, oldVal) => {
                unbindElementsWatch();

                const {width, height} = this.mainShapeDimensions;

                // Revert to old params
                console.log('configuratorController::$watch elements revert to valid params');
                for (const element of this.visibleElements) {
                    const maxD = Math.floor(0.9 * Math.min(width, height));
                    const maxWidth = Math.floor(0.9 * width);
                    const maxHeight = Math.floor(0.9 * height);

                    switch (element.shape) {
                        case this.MainShapeType.Circle:
                            if (element.d < 2) {
                                element.d = 2;
                            }

                            if (element.d >= maxD) {
                                element.d = maxD - 1;
                            }
                            break;
                        case this.MainShapeType.RoundedRect:
                            if (element.w < 4) {
                                element.w = 4;
                            }

                            if (element.h < 4) {
                                element.h = 4;
                            }

                            if (element.w >= maxWidth) {
                                element.w = maxWidth - 1;
                            }

                            if (element.h >= maxHeight) {
                                element.h = maxHeight - 1;
                            }
                            break;
                    }
                }

                // Show to user old errors!
                omitNextElementsValidation = true;

                unbindElementsWatch = this.$scope.$watch(
                    elementsChangeModel, elementsChangeCallback, true
                );
            };

            const elementsChangeModel = () => this.elements.map(element => {
                let {rawElement, ...localModel} = element;

                return localModel;
            });

            const elementsChangeCallback = (newVal, oldVal) => {
                if (newVal.length < 1) return;

                console.log('configuratorController::elementsChangeCallback', newVal);

                this.sanitizeElementsParams();

                if(omitNextElementsValidation) {
                    omitNextElementsValidation = false;
                } else if(!this.validateElements()) {
                    revertWrongElementsChanges();
                    return false;
                }

                const hasVisibleElements = this.visibleElements.length ? true : false;

                if(hasVisibleElements && !this.hadVisibleElements){
                    // When first hole added - store current cut mode
                    console.log('configuratorController::elementsChangeCallback -> store cut mode', this.activeCutMode);
                    this.storedCutMode = this.activeCutMode;
                }

                this.redrawElements();
                this.setAvailableCutModes();

                if(!hasVisibleElements && this.hadVisibleElements && this.storedCutMode !== this.activeCutMode && this.storedCutMode.available === true){
                    // When last hole removed - restore cut mode
                    console.log('configuratorController::elementsChangeCallback -> restore cut mode', this.storedCutMode);
                    this.setActiveCutMode(this.storedCutMode);
                }

                this.calculatePriceDebounce();

                this.hadVisibleElements = hasVisibleElements;

            };

            unbindElementsWatch = this.$scope.$watch(
                elementsChangeModel, elementsChangeCallback, true
            );

            this.$scope.$watch(
                () => this.isMobile,
                (isMobile, wasMobile) => {
                    if(wasMobile == isMobile) {
                        return;
                    }

                    let newPadding = isMobile ? this.CPpadding.mobile : this.CPpadding.desktop;

                    if(this.WindowSizeTimeout) {
                        this.$timeout.cancel(this.WindowSizeTimeout);
                        this.WindowSizeTimeout = null;
                    }

                    this.WindowSizeTimeout = this.$timeout(
                        () => {
                            console.log('!setPadding', newPadding);
                            this.CP.setPadding(newPadding);
                            console.log('!setMobile', isMobile);
                            this.CP.setMobile(isMobile);
                        },
                        300
                    )
                },
                true
            );

            this.$scope.$watch(() => this.CPdimensions, (newVal, oldVal) => {
                console.log('$$ dimensions', this.CPdimensions);
                if (!newVal) return;
                if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;

                if (this.CPdimensionsTimeout) {
                    this.$timeout.cancel(this.CPdimensionsTimeout);
                    this.CPdimensionsTimeout = null;
                }

                this.CPdimensionsTimeout = this.$timeout(
                    () => {
                        this.CP.setView(this.CPdimensions.x, this.CPdimensions.y);
                    },
                    100
                );

            }, true);

            this.$scope.$watch(
                () => this.$scope.elementWidth,
                (newVal, oldVal) => {
                    if (!newVal) return;
                    if (newVal === this.CPdimensions.x) return;

                    this.CPdimensions = {
                        x: newVal,
                        y: newVal / 1.5
                    };
                }
            );

            let validationParamsChangeModel = () => {
                return {'activeCutMode': this.activeCutMode, 'visibleElements': this.visibleElements.length, 'mainShapeType': this.mainShape.type, 'materialSettings': this.materialSettings}
            };

            this.$scope.$watch(validationParamsChangeModel,
                    (newVal, oldVal) => {
                    if(this.mainShapeParam.validator) {
                        this.mainShapeParam.validator.setData(newVal);
                    }
            }, true);

            let defferedFocusedParamWatch = null;

            this.$rootScope.$on('focusedParam', (event, newVal) => {
                if (!this.mainShape.rawElement) return;
                if (newVal === this.focusedParam) {
                    console.log(`configuratorController::$on('focusedParam') -> no change`, newVal);
                    return;
                }

                this.focusedParam = newVal;

                if (defferedFocusedParamWatch) {
                    this.$timeout.cancel(defferedFocusedParamWatch);
                    defferedFocusedParamWatch = null;
                }

                defferedFocusedParamWatch = this.$timeout(() => {
                    console.log(`configuratorController::$on('focusedParam')`, newVal);

                    if (!newVal) {
                        this.mainShape.rawElement.setActiveDescription(null);

                        console.log(`configuratorController::setActiveDescription ${newVal}`);

                        return;
                    }

                    if (newVal.startsWith('hole')) {
                        console.log(newVal, newVal.replace('hole', ''));
                        newVal = newVal.replace('hole', '');
                        if (this.activeElement && this.activeElement.rawElement)
                            this.activeElement.rawElement.holeElement.setActiveDescription(newVal);
                        console.log(`configuratorController::setActiveDescription ${newVal}`, this.activeElement.rawElement.holeElement);
                    } else {
                        if (this.mainShape.rawElement)
                            this.mainShape.rawElement.setActiveDescription(newVal);
                        console.log(`configuratorController::setActiveDescription ${newVal}`, this.mainShape.rawElement);
                    }
                }, 100);
            });

            this.$scope.$watch(() => {
                return this.activeElement;
            }, (newVal, oldVal) => {
                // if (!newVal) return;
                if (newVal === oldVal) return;
                this.markElementsActive();
            });

            this.$scope.$watch(() => {
                return Object.values(this.materialSettings).map(material => material ? material.id : -1);
            }, (newVal, oldVal) => {
                if (!newVal) return;
                this.setAvailableHoleTypes();
                this.setAvailableMainshapeTypes();
                this.setAvailableCutModes();
                this.calculatePriceDebounce();
            }, true);

            let omitNextQuantityWatch = false;

            this.$scope.$watch(() => this.quantity, (newVal, oldVal) => {
                if (omitNextQuantityWatch) {
                    omitNextQuantityWatch = false;
                    return;
                }

                this.errors = [];

                if (newVal < 1) {
                    omitNextQuantityWatch = true;
                    this.quantity = 1;
                    this.calculatePriceDebounce();
                    return;
                };

                if (newVal > 9999) {
                    omitNextQuantityWatch = true;
                    this.quantity = 9999;
                    this.calculatePriceDebounce();

                    this.errors.push({
                        message: this.translate.t('configurator.errors.maximumQuantity', {quantity: '9999'}),
                        type: 'error'
                    });

                    return;
                };

                this.calculatePriceDebounce();
            });

            let unbindMainShapeWatch = null;
            //let omitNextMainShapeWatch = false;

            const revertMainShapeChanges = (newVal, oldVal) => {
                unbindMainShapeWatch();

                // Revert to old params
                let revertMainShapeChangesConsoleLog = '!configuratorController::$watch mainShape revert to old params:';

                if(oldVal) {
                    for (const property of Object.keys(oldVal)) {
                        if (property == 'type' || property == 'oldType') continue;

                        revertMainShapeChangesConsoleLog += ` ${property}: ${this.mainShape[property]} => ${oldVal[property]}`
                        this.mainShape[property] = oldVal[property];
                    }
                }

                console.log(revertMainShapeChangesConsoleLog);

                // Show to user old errors!
                this.omitNextMainShapeWatch = true;

                unbindMainShapeWatch = this.$scope.$watch(
                    mainShapeChangeModel, mainShapeChangeCallback, true
                );
            };

            const mainShapeChangeModel = () => {
                if (!this.mainShape) return null;

                let {rawElement, ...localModel} = this.mainShape;

                return localModel;
            };

            const mainShapeChangeCallback = (newVal, oldVal) => {

                console.log(`mainShapeChangeCallback`);

                if (this.omitNextMainShapeWatch) {
                    this.omitNextMainShapeWatch = false;
                    return false;
                }

                // Model validation
                if (!this.validateMainShape() || !this.validateMainShapeParams()) {
                    revertMainShapeChanges(newVal, this.lastProperMainShapeModel);
                    this.redrawMainShape();
                    return false;
                }

                this.redrawMainShape();

                if (!this.validateMainShapeSize()) {
                    revertMainShapeChanges(newVal, this.lastProperMainShapeModel);
                    this.redrawMainShape();
                    this.calculatePriceDebounce();
                    return false;
                } else {
                    const properModel = angular.copy(newVal);
                    this.lastProperMainShapeModel = properModel;
                }

                this.setAvailableHoleTypes();
                this.setAvailableCutModes();
                this.calculatePriceDebounce();
            };

            unbindMainShapeWatch = this.$scope.$watch(
                mainShapeChangeModel, mainShapeChangeCallback, true
            );

            const cutModeChangeCallback = (newval, oldval) => {
                if (!this.validateMainShapeSize()) {
                    revertMainShapeChanges(newval, this.lastProperMainShapeModel);
                    this.redrawMainShape();
                    this.calculatePriceDebounce();
                }
            }

            let unbindCutModeWatch = this.$scope.$watch(
                () => this.activeCutMode, cutModeChangeCallback, true
            );

            let unbindMaterialSettingsWatch = null;

            const revertMaterialSettingsChanges = (newVal, oldVal) => {
                unbindMaterialSettingsWatch();

                // Revert to old params
                console.log('!configuratorController::$watch materialSettings revert to old params:', this.materialSettings, this.lastProperMaterialSettings);
                this.materialSettings = angular.copy(this.lastProperMaterialSettings);
                this.activeMaterial = this.materialSettings.type;
                this.changeMaterialUrl(this.materialSettings.type).then(
                    () => {
                        this.forceRedrawMainShape();
                    }
                );

                // Show to user old errors!
                this.omitNextMaterialSettingsWatch = true;

                unbindMaterialSettingsWatch = this.$scope.$watch(
                    materialSettingsChangeModel, materialSettingsChangeCallback, true
                );
            };

            const materialSettingsChangeModel = () => {
                if (!this.materialSettings) return null;

                return this.materialSettings;
            };

            const materialSettingsChangeCallback = (newVal, oldVal) => {

                if(newVal === oldVal || newVal === null || oldVal === null) {
                    console.log('%% configuratorController::$watch materialSettings not changed', newVal, oldVal);
                    return;
                }

                this.setAvailableMainshapeTypes();
                this.setAvailableCutModes();

                if (this.omitNextMaterialSettingsWatch) {
                    console.log('!configuratorController::$watch omit', newVal, oldVal);
                    this.omitNextMaterialSettingsWatch = false;
                    if(this.validateMaterialCutModes()) {
                        return false;
                    }
                }

                console.log('%% configuratorController::$watch materialSettings:', newVal, oldVal);

                this.errors = [];

                // Model validation
                if (!this.validateMainShapeSize() || !this.validateMaterialCutModes()) {
                    console.log('!validation failed, revert', this.lastProperMaterialSettings);
                    revertMaterialSettingsChanges(newVal, this.lastProperMaterialSettings);
                    return false;
                } else {
                    const properModel = angular.copy(newVal);
                    this.lastProperMaterialSettings = properModel;
                }
            };

            unbindMaterialSettingsWatch = this.$scope.$watch(
                materialSettingsChangeModel, materialSettingsChangeCallback, true
            );

            for (let material of window.configuratorMaterials) {
                material.available = true;
                material.image = material.image !== null ? material.image.src : null;
            }

            this.materials = window.configuratorMaterials;

            Validator.setMaterialsMaxDimensions(this.materials);

            if (!this.materialSlug) {
                console.log('!getMaterials 1');
                this.state.go('.', {materialSlug: this.materials[0].slug}, {notify: false});
                return true;
            }

            const activeMaterialType = this.materials
                .filter(material => material.slug === this.materialSlug);

            if (activeMaterialType.length < 1) {
                console.log('!getMaterials 2');
                this.state.go('.', {materialSlug: this.materials[0].slug}, {notify: false});
                return true;
            }

            this.changeMaterialType(activeMaterialType[0], true);

            if (this.model) {
                this.initModel();
                return;
            }

            this.changeMainShapeType(this.mainShapes[0]);
            this.setActiveCutMode(this.cutModes[0]);
            this.lastProperMainShapeModel = this.mainShape;
        });

        const paddingInterval = this.$interval(
            () => {
                console.log('paddingInterval cancel', this.mainShape.rawElement.haveSize);
                if (this.mainShape.rawElement.haveSize) {
                    this.$interval.cancel(paddingInterval);
                }
                this.CP.redrawView();
                this.initComplete();
                console.log('paddingInterval');
            },
            100
        );
    }

    get svgBlob() {
        return this.CP.getBlobUrl();
    }

    get localModel() {
        const {rawElement, oldType, ...localMainShapeModel} = this.mainShape;

        localMainShapeModel.totalLength = this.mainShape.rawElement.getLength();
        localMainShapeModel.oryginalBbox = {
            width: this.mainShape.rawElement.oryginalBbox.width,
            height: this.mainShape.rawElement.oryginalBbox.height
        };

        let localElementsModel = this.visibleElements
            .map(element => {
                const {rawElement, removed, ...localModel} = element;

                return localModel;
            });

        return {
            elements: localElementsModel,
            mainShape: localMainShapeModel,
            scale: this.mainShape.rawElement.getScale(),
            cutMode: this.activeCutMode.type.name,
            material: this.materialSettings
        };
    }

    initModel() {
        if(typeof this.model === 'string' || this.model instanceof String) {
            this.initModelMainShape();
            this.initModelCutMode();
        }
    }

    initModelMainShape() {
        console.log('#initModelMainShape');
        this.model = JSON.parse(atob(this.model));

        for(let mainShape of this.mainShapes){
            if(this.model.mainShape.type.name == mainShape.type.name){
                delete this.model.mainShape.totalLength;
                delete this.model.mainShape.oryginalBbox;
                delete this.model.mainShape.name;
                this.model.mainShape.rawElement = null;
                this.model.mainShape.oldType = null;
                this.model.mainShape.type  = mainShape.type;
                this.activeMainShape = mainShape;
                this.mainShape = this.model.mainShape;
            }
        }

        console.log('initModelMainShape', this.mainShape);
    }

    initModelCutMode() {
        console.log('initModelCutMode', this.mainShape);
        for (let cutMode of this.cutModes) {
            if (this.model.cutMode == cutMode.type.name) {
                this.setActiveCutMode(cutMode);
            }
        }
    }

    initModelMaterial() {
        console.log('#initModelMaterial', this.model.material, this.materials);
        const loadedMaterialType = this.materials.find(material => material.id === this.model.material.type.id);
        this.model.material.type.items = loadedMaterialType.items;

        console.log('#loadedMaterialType', loadedMaterialType);

        // Check if the saved material subType exists in the fresh data
        // ...

        if (this.model.material.subType) {
            let loadedMaterialSubType = loadedMaterialType.items.find(item => item.id === this.model.material.subType.id);

            if (!loadedMaterialSubType) {
                // Saved material subtype does not exists in the database, select the first one
                loadedMaterialSubType = loadedMaterialType.items[0];
                this.model.material.subType = loadedMaterialSubType;
            } else {
                // Saved material subtype still exists in the database
                this.model.material.subType.items = loadedMaterialSubType.items;
            }

            console.log('#loadedMaterialSubType', loadedMaterialSubType);

            // Check if the saved material size exists in the fresh data
            const materialSizeExists = loadedMaterialSubType.items.find(materialSubType => materialSubType.id === this.model.material.size.id);
            if (!materialSizeExists) {
                console.log('#materialSize (1) does not exists, select first from the list');
                this.model.material.size = loadedMaterialSubType.items[0];
            }
        } else {
            // Check if the saved material size exists in the fresh data
            const materialSizeExists = loadedMaterialType.items.find(materialType => materialType.id === this.model.material.size.id);
            if (!materialSizeExists) {
                console.log('#materialSize (2) does not exists, select first from the list');
                this.model.material.size = loadedMaterialType.items[0];
            }
        }

        this.materialSettings = this.model.material;
        if(this.materialSettings.subType) {
            this.materialSettings.type.items.some(item => {
                if (item.id == this.materialSettings.subType.id) {
                    this.materialSettings.subType = item;
                    return true;
                }
            });
        }
    }

    initModelHoles() {
        if (this.model.elements) {
            for(let element of this.model.elements) {
                element.type = ElementType.enumValueOf(element.type.name);
                element.shape = MainShapeType.enumValueOf(element.shape.name);
                this.elements.push(element);
            }
        }
    }

    // Check available hole shapes for ANY available cut modes
    setAvailableHoleTypes() {
        console.log('holes', this.holes);
        const materialData = this.materialSettings.subType ? this.materialSettings.subType : this.materialSettings.type;

        const availableHoleTypes = [];

        if (!materialData) {
            this.availableHoleTypes = availableHoleTypes;
            return availableHoleTypes;
        }

        const mainShapeTag = this.mainShape.type.name;

        for (const cutMode of this.cutModes) {
            const tag = cutMode.type.name;

            if (!materialData.cutPrices[`${tag}Available`]) continue;

            if (!materialData.availableMainShapes[tag][mainShapeTag]) continue;

            for (const shape in materialData.availableHoleTypes[tag]) {
                if (!materialData.availableHoleTypes[tag][shape]) continue;

                const holeType = this.holes.filter(h => h.shape.name === shape)[0] || null;

                if (!holeType) continue;

                availableHoleTypes.push(holeType);
            }
        }

        this.availableHoleTypes = availableHoleTypes;
        return availableHoleTypes;
    }

    get visibleElements() {
        return this.elements.filter(element => !element.removed);
    }

    get mainShapeDimensions() {
        const originalBbox = this.mainShape.rawElement ? this.mainShape.rawElement.oryginalBbox : null;

        const bboxWidth = originalBbox ? originalBbox.width : 0;
        const bboxHeight = originalBbox ? originalBbox.height : 0;

        return {
            width: bboxWidth,
            height: bboxHeight
        };
    }

    get canAddHole() {
        if (this.availableHoleTypes.length < 1) return false;

        const {width, height} = this.mainShapeDimensions;

        return width <= 2030 && height <= 3030;
    }

    changeMaterialUrl(material, subType = null, size = null) {

        let subTypeSlug = subType ? subType.slug : null;
        let sizeSlug = size ? size.slug : null;

        let newSlug1 = null;
        let newSlug2 = null;

        if (!subType) {
            newSlug1 = sizeSlug;
        } else {
            newSlug1 = subTypeSlug;
            newSlug2 = sizeSlug;
        }

        this.urlParts = {material: true, subType: !!subType, size: !!size};

        console.log(`** configuratorController::changeMaterialUrl-> ${material.slug} / ${subTypeSlug} / ${sizeSlug}`);

        return new Promise((resolve, reject) => {
            // SEO

            const title = (size && size.seo && size.seo.title ? size.seo.title : false)
                || (subType && subType.seo && subType.seo.title ? subType.seo.title : false)
                || material.seo.title
                || `${translate('configurator_title')} (${material.name})`;
            this.$window.document.title = title;

            const description = (size && size.seo && size.seo.description ? size.seo.description : false)
                || (subType && subType.seo && subType.seo.description ? subType.seo.description : false)
                || material.seo.description
                || `${translate('configurator_title')} (${material.name})`;
            this.$window.document.querySelector('meta[name="description"]').setAttribute("content", description);

            const fullDescription = (size && size.description ? size.description : false)
                || (subType && subType.description ? subType.description : false)
                || material.description
                || `${translate('configurator_title')} (${material.name})`;
            angular.element(this.$window.document.getElementById('configurator-hidden-description')).html(fullDescription);

            const h1 = (size && size.seo && size.seo.h1 ? size.seo.h1 : false)
                || (subType && subType.seo && subType.seo.h1 ? subType.seo.h1 : false)
                || material.seo.h1
                || this.h1
                || `${translate('configurator_title')} (${material.name})`;
            this.h1 = h1;
            angular.element(this.$window.document.getElementById('configurator-to-hide-title-container')).remove();

            const breadcrumbs = `${translate('configurator_title')} (${material.name})`;
            let breadcrumbsList = angular.element(this.$window.document.getElementsByClassName('breadcrumbs')[0]);
            breadcrumbsList.find('.breadcrumb-item').remove();
            angular.element(breadcrumbsList.find('li')[1].children[1]).html(`<span property="name">${breadcrumbs}</span>`);

            if(subType) {
                angular.element(breadcrumbsList.find('ol')[0])
                    .append(angular.element(`<li class="breadcrumb-item" property="itemListElement" typeof="ListItem"><span>»</span><a property="item" typeof="WebPage" href><span property="name">${subType.name}</span></a><meta property="position" content="3"></li>`))
            }

            if(size) {
                let sizeBreadcrumbsItemPosition = 3;
                if(subType) {
                    sizeBreadcrumbsItemPosition = 4;
                }
                angular.element(breadcrumbsList.find('ol')[0])
                    .append(angular.element(`<li class="breadcrumb-item" property="itemListElement" typeof="ListItem"><span>»</span><span property="name">${size.name}</span><meta property="position" content="${sizeBreadcrumbsItemPosition}"></li>`))
            }

            if (this.materialSlug !== material.slug || this.slug1 !== newSlug1 || this.slug2 !== newSlug2) {

                let routeParams = {materialSlug: material.slug, slug1: newSlug1, slug2: newSlug2};

                // Ustaw URL i nie uruchamiaj ponownie kontrolera (notify = false) jeżeli ustawiamy slug1 lub slug2
                if (document.getElementById('cookie-wall-modal') !== null) {
                    console.log('** configuratorController::delayStateChange');
                    window.addEventListener('popupClosed', () => {
                        this.setState(routeParams, newSlug1, newSlug2, material, reject, resolve);
                    });
                } else {
                    console.log('** configuratorController::setStateWithoutDelay');
                    this.setState(routeParams, newSlug1, newSlug2, material, reject, resolve);
                }
            } else {
                resolve();
            }
        });
    }

    setState(routeParams, newSlug1, newSlug2, material, reject, resolve) {
        this.state.go('.', routeParams, {notify: !newSlug1, location: newSlug1 ? 'replace' : true}).then(
            () => {
                this.slug1 = newSlug1;
                this.slug2 = newSlug2;
                this.materialSlug = material.slug;
                console.log(`* configuratorController::changedMaterialUrl resolve() ->`, routeParams);

                if (shopId === 2) {
                    this.setCanonicalUrl(this.state.href(this.state.current.name, routeParams));
                }
                resolve();
            },
            () => {
                console.log(`* configuratorController::notChangeMaterialUrl reject() -> ERROR`, routeParams);
                reject();
            }
        );
    }

    setCanonicalUrl(currentUrl) {

        const headerElement = angular.element(window.document.getElementsByTagName('head')[0]);

        let canonicalElement = headerElement.find('link[rel="canonical"]') ? headerElement.find('link[rel="canonical"]')[0] : null;
        if (canonicalElement) {
            canonicalElement.remove();
        }

        canonicalElement = angular.element(`<link rel="canonical" href="${window.location.origin}${currentUrl}" />`);
        headerElement.append(canonicalElement);
    }

    getDefaultSubTypeAndSize(subTypes, slug1 = null, slug2 = null) {
        if (!slug1 || !slug2) {
            return {subType: subTypes[0], size: subTypes[0].items[0]};
        }

        let subType = subTypes.find(subType => slug1 === subType.slug);
        let size = null;

        if (subType) {
            size = subType.items.find(subTypeSize => slug2 === subTypeSize.slug);
        }

        console.log(`* getDefaultSubTypeAndSize`, subType, size);

        if (!subType || !size) {
            return {subType: subTypes[0], size: subTypes[0].items[0]};
        }

        return {subType: subType, size: size};
    }

    getDefaultSize(sizes, slug1 = null) {
        if (!slug1) {
            return sizes[0];
        }

        let size = sizes.find(size => size.slug === slug1);

        if (!size) {
            return sizes[0];
        }

        console.log(`* getDefaultSize`, size);

        return size;
    }

    changeMaterialType(material, init = false) {
        // Jeśli init == true - spróbuj ustawić parametry subType i size ze slugów
        let slug1 = init ? this.slug1 : null;
        let slug2 = init ? this.slug2 : null;

        if (init && !slug1 && !slug2) {
            this.omitChangeMaterialUrl = true;
        }

        this.changeMaterialUrl(material, null, null).then(
            () => {
                console.log(`configuratorController::changeMaterialType -> ${material.name}`);
                this.activeMaterial = material;

                const type = material;
                let subType = null;
                let size = null;

                if(this.model && !this.loadedModelMaetrialSet){
                    this.changeMaterialUrl(material, this.model.material.subType, this.model.material.size);
                    this.initModel();
                    this.initModelMaterial();
                    this.initModelHoles();
                    this.loadedModelMaetrialSet = true;
                    this.initComplete();
                } else {
                    if (material.items && material.items.length > 0) {
                        if (material.items[0].items && material.items[0].items.length > 0) {
                            let subTypeSize = this.getDefaultSubTypeAndSize(material.items, slug1, slug2);
                            subType = subTypeSize.subType;
                            size = subTypeSize.size;
                            console.log(`* configuratorController::setSubType, init = ${init}, -> ${subType.name}, size -> ${size.name}`);
                            if(this.omitChangeMaterialUrl) {
                                this.omitChangeMaterialUrl = false;
                            } else {
                                console.log(`** changeMaterialUrl 1`);
                                this.changeMaterialUrl(material, subType, size);
                            }
                        } else {
                            size = this.getDefaultSize(material.items, slug1);
                            console.log(`* configuratorController::setSubType -> null, size -> ${size.name}`);
                            console.log(`** changeMaterialUrl 2`);
                            if(this.omitChangeMaterialUrl) {
                                this.omitChangeMaterialUrl = false;
                            } else {
                                this.changeMaterialUrl(material, null, size);
                            }
                        }
                    }
                    this.materialSettings = {
                        type: type,
                        subType: subType,
                        size: size
                    };
                }

                this.forceRedrawMainShape();
            }
        );

    }

    changeMaterialSubType(material) {
        console.log(`!configuratorController::changeMaterialSubType -> ${material.name}`);

        this.omitNextMaterialSettingsWatch = false;

        let materialSize = null;

        if (material.items && material.items.length > 0) {
            materialSize = material.items[0];
            this.materialSettings.size = materialSize;
        }

        this.changeMaterialUrl(this.materialSettings.type, material, materialSize);
    }

    changeMaterialSize(size) {
        console.log(`!configuratorController::changeMaterialSize -> ${size.name}`);

        this.changeMaterialUrl(this.materialSettings.type, this.materialSettings.subType, size).then(() => {
            this.materialSettings.size = size;
        });
    }

    setActiveElement(activeElement) {
        this.activeElement = activeElement;
    }

    setActiveCutMode(cutMode) {
        this.activeCutMode = cutMode;

        if (this.mainShapeParam.validator) {
            this.mainShapeParam.validator.setActiveCutMode(cutMode);
        }

        if (!this.activeCutMode) {
            return false;
        }

        if (this.oldActiveCutMode) {
            console.log(`configuratorController::setActiveCutMode ${this.oldActiveCutMode.type.name} => ${this.activeCutMode.type.name} (recalculatePrice: ${this.activeCutMode && this.oldActiveCutMode !== this.activeCutMode})`, cutMode);

            if (this.oldActiveCutMode !== this.activeCutMode) this.calculatePriceDebounce();
        } else {
            console.log(`configuratorController::setActiveCutMode null => ${this.activeCutMode.type.name} (recalculatePrice: true)`, cutMode);
            this.calculatePriceDebounce();
        }

        this.oldActiveCutMode = this.activeCutMode;
    }

    setAvailableMainshapeTypes() {
        const materialData = this.materialSettings.subType ? this.materialSettings.subType : this.materialSettings.type;

        const availableMainShapeTypes = [];

        if (!materialData) {
            this.availableMainShapeTypes = availableMainShapeTypes;
            return availableMainShapeTypes;
        }

        for (const type of MainShapeType) {
            if (!type.name) continue;

            for (const cutMode of this.cutModes) {
                const tag = cutMode.type.name;

                if (!materialData.cutPrices[`${tag}Available`]) continue;

                if (materialData.availableMainShapes[tag][type.name]) {
                    const mainShapeType = this.mainShapes.filter(ms => ms.type.name === type.name)[0] || null;

                    if (!mainShapeType) continue;

                    availableMainShapeTypes.push(mainShapeType);
                    break;
                }
            }
        }

        this.availableMainShapeTypes = availableMainShapeTypes;

        console.log('configuratorController::setAvailableMainshapeTypes ', this.availableMainShapeTypes);

        return availableMainShapeTypes;
    }

    changeMainShapeType(shape) {

        console.log('configuratorController::changeMainShapeType', shape);

        if (shape.type === this.mainShape.type) return false;

        if (this.visibleElements.length > 0) {
            if (!confirm(this.translate.t('configurator.warnings.holesInProject')))
                return false;

            for (const element of this.visibleElements) {
                element.removed = true;
            }
        }

        this.activeMainShape = shape;

        if (this.mainShape.type) {
            let oldParams = this.mainShapeParams.get(this.mainShape.type);

            for (const [property, value] of oldParams.defaults) {
                oldParams.defaults.set(property, this.mainShape[property]);
            }

            this.mainShape.oldType = this.mainShape.type;
        }

        // Get type defaults
        if (!this.mainShapeParams.has(shape.type)) return false;

        let params = this.mainShapeParams.get(shape.type);

        for (const [property, value] of params.defaults) {
            this.mainShape[property] = value;
        }

        this.mainShape.type = shape.type;
    }

    get mainShapeParam() {
        if (this.mainShapeParams.has(this.mainShape.type)) {
            return this.mainShapeParams.get(this.mainShape.type)
        }

        return null;
    }

    validateMainShape() {

        this.errors = [];

        if (!this.mainShapeParams.has(this.mainShape.type)) return false;

        const params = this.mainShapeParams.get(this.mainShape.type);

        if (!params.validators) return true;

        if (params.validators.length == 0) return true;

        const {rawElement, oldType, ...localMainShapeModel} = this.mainShape;

        for (const validator of params.validators) {
            if (typeof validator != 'function') continue;

            const hasError = validator(localMainShapeModel);

            if (hasError) {
                const errorMessage = Array.isArray(hasError.message) ? this.translate.t(...hasError.message) : this.translate.t(hasError.message);

                if(hasError.hasOwnProperty('propName') && hasError.hasOwnProperty('propValue')) {
                    this.setLastProperMainShapeModelProperty(hasError.propName, hasError.propValue);
                }

                this.errors.push({
                    message: errorMessage,
                    type: 'error'
                });

                return false;
            }
        }

        return true;
    }

    validateMainShapeParams() {
        const {oldType, type, rawElement, ...params} = this.mainShape;

        for (const paramName of Object.keys(params)) {
            const param = params[paramName];

            if (paramName != 'text' && paramName != 'fontName' && paramName != 'importantSize') {
                if(!/^\d+$/.test(param)) {
                    this.errors.push({
                        message: this.translate.t('configurator.errors.dimensionsOnlyNumber'), // Wymiary muszą być liczbami.
                        type: 'error'
                    });

                    return false;
                }
            }
        }

        return true;
    }

    validateMainShapeSize() {

        if (!this.mainShape.rawElement || !this.mainShape.rawElement.haveSize) {
            return true;
        }

        let {width, height} = this.mainShapeDimensions;
        width = Math.round(width);
        height = Math.round(height);

        console.log('!validateMainShapeSize', width, height);

        if (width < 50 || height < 50) {

            this.errors.push({
                message: this.translate.t('configurator.errors.minimumSize', {minWidth: 50, minHeight: 50}), // Minimalny rozmiar materiału to 50*50mm.
                type: 'error'
            });

            return false;
        }

        // Tekst
        if (this.mainShape.type === this.MainShapeType.Text) {
            // Jeżeli tekst ma dwie linijki - wysokość rzeczywista elementu jest inna niż podana w konfiguratorze
            let {maxWidth, maxHeight} = this.mainShapeParam.validator.maxDimensions(this.mainShape, width, height);

            maxHeight = this.checkMaximumTextHeight(maxHeight);

            if (width <= maxWidth && this.mainShape.h <= maxHeight) {
                return true;
            }

            let newWidth = width;
            let newHeight = height;

            if (width > maxWidth) {
                newWidth = maxWidth;
            }
            if (this.mainShape.h > maxHeight) {
                newHeight = maxHeight;
            }

            // Ustaw maksymalną poprawną wysokość tekstu
            if(newHeight >= 50) {
                this.setLastProperMainShapeModelProperty('w', newWidth);
                this.setLastProperMainShapeModelProperty('h', newHeight);
                this.setLastProperMainShapeModelProperty('text', this.mainShape.text);
                this.setLastProperMainShapeModelProperty('fontName', this.mainShape.fontName);

                this.errors.push({
                    message: this.translate.t('configurator.errors.maximumShapeSize', {
                        maxWidth: this.mainShapeParam.validator.getMaximumShapeSize().w,
                        maxHeight: this.mainShapeParam.validator.getMaximumShapeSize().h
                    }), // Maksymalny rozmiar materiału dla wybranego kształtu to 3030*2020mm.
                    type: 'error'
                });

                return false
            }
        }

        const maxDimensionsForCutMode = Validator.getMaxDimensionsForCutMode(this.activeCutMode.type.name, this.materialSettings.type ? this.materialSettings.type.id : null, this.materialSettings.subType ? this.materialSettings.subType.id : null);
        console.log('maxDimm', maxDimensionsForCutMode);

        if (width > maxDimensionsForCutMode.w || height > maxDimensionsForCutMode.h) {
            if (width > maxDimensionsForCutMode.w) {
                this.setLastProperMainShapeModelProperty('w', maxDimensionsForCutMode.w);
            }
            if (height > maxDimensionsForCutMode.h) {
                this.setLastProperMainShapeModelProperty('h', maxDimensionsForCutMode.h);
            }

            let messageTranslationKey = '';

            switch (this.activeCutMode.type.name) {
                case 'laser':
                    messageTranslationKey = 'configurator.errors.maximumSizeLaserCut';
                    break;
                case 'frez':
                    messageTranslationKey = 'configurator.errors.maximumSizeFrezCut';
                    break;
                case 'chainPolished':
                    messageTranslationKey = 'configurator.errors.maximumSize';
                    break;
                default:
                    messageTranslationKey = 'configurator.errors.maximumShapeSize';
            }

            this.errors.push({
                message: this.translate.t(messageTranslationKey, {
                    maxWidth: maxDimensionsForCutMode.w,
                    maxHeight: maxDimensionsForCutMode.h
                }), // Maksymalny rozmiar materiału to ${materialData.max_width}*${materialData.max_height}mm.,
                type: 'error'
            });

            return false;
        }

        return true;
    }

    setLastProperMainShapeModelProperty(property, value) {

        console.log('!setLastProperMainShapeModelProperty', this.lastProperMainShapeModel, property, value);

        if (!this.lastProperMainShapeModel.hasOwnProperty(property)) {
            return false;
        }

        switch(this.mainShape.type) {
            case this.MainShapeType.Circle:
            case this.MainShapeType.HalfCircle:
            case this.MainShapeType.QuarterCircle:
                if(property === 'w' || property === 'h') {
                    property = 'd';
                }
                if(this.mainShape.type === this.MainShapeType.QuarterCircle) {
                    value = value * 2;
                }
                break;
            case this.MainShapeType.Trapezoid:
                if(property === 'w') {
                    let newWidth = value - this.mainShape.t1 - this.mainShape.t2;
                    let t1 = 0;
                    let t2 = 0;
                    if(newWidth >= 1) {
                        t1 = this.mainShape.t1;
                        t2 = this.mainShape.t2;
                    } else {
                        let widthDifference = Math.abs(newWidth / 2);
                        t1 = this.mainShape.t1 - widthDifference > 0 ? this.mainShape.t1 - widthDifference : 0;
                        t2 = this.mainShape.t2 - widthDifference > 0 ? this.mainShape.t2 - widthDifference : 0;
                        newWidth = 1;
                        if(t1 + t2 + newWidth > value) {
                            newWidth = value;
                            t1 = t2 = 0;
                        }
                    }
                    value = newWidth;
                    this.setLastProperMainShapeModelProperty('t1', t1);
                    this.setLastProperMainShapeModelProperty('t2', t2);
                }
                break;
            case this.MainShapeType.Arrow:
                if(property === 'w') {
                    let arrowHeadWidth = value - this.mainShape.width > 0 ? value - this.mainShape.width : 0;
                    value = value - arrowHeadWidth;
                    this.setLastProperMainShapeModelProperty('w2', arrowHeadWidth);
                } else if(property === 'h') {
                    let arrowHeadHeight = value - this.mainShape.height > 0 ? Math.floor(value - this.mainShape.height / 2) : 0;
                    value = value - arrowHeadHeight;
                    this.setLastProperMainShapeModelProperty('t', arrowHeadHeight);
                }
                break;
            case this.MainShapeType.Diamond:
                if(property === 'w') {
                    if(this.mainShape.w2 > value) {
                        property = 'w2';
                    }
                } else if(property === 'h') {
                    value = value - this.mainShape.h2;
                    this.setLastProperMainShapeModelProperty('h2', this.mainShape.h2);
                }
                break;
        }

        this.lastProperMainShapeModel[property] = value;
    }

    validateMaterialCutModes() {
        console.log('!validateMaterialCutModes');
        const availableCutModes = this.cutModes.filter(cm => cm.available);

        if (availableCutModes.length > 0) return true;

        this.errors.push({
            message: this.translate.t('configurator.errors.shapeNotAvailble'), // Wybrany kształt nie jest dostępny w wybranym materiale.,
            type: 'error'
        });

        return false;
    }

    validateElements() {
        this.errors = [];

        const elements = this.visibleElements;

        if (elements.length < 1) return true;

        for (const element of elements) {

            switch (element.shape) {
                case this.MainShapeType.Circle:
                    if (element.d < 2) {
                        console.log(`configuratorController::validateElements d: ${element.d} < 2`);

                        this.errors.push({
                            message: this.translate.t('configurator.errors.minimumCircleDiameter', {min: 2}), // Minimalna średnica otworu to 2mm.,
                            type: 'error'
                        });

                        return false;
                    }
                    break;
                case this.MainShapeType.RoundedRect:
                    if (element.w < 4) {
                        console.log(`configuratorController::validateElements w: ${element.w} < 4`);

                        this.errors.push({
                            message: this.translate.t('configurator.errors.minimumCircleWidth', {min: 4}), // Minimalna szerokość otworu to 2mm.,
                            type: 'error'
                        });

                        return false;
                    }

                    if (element.h < 4) {
                        console.log(`configuratorController::validateElements h: ${element.h} < 4`);

                        this.errors.push({
                            message: this.translate.t('configurator.errors.minimumCircleHeight', {min: 4}), // Minimalna wysokość otworu to 2mm.,
                            type: 'error'
                        });

                        return false;
                    }
                    break;
            }
        }

        return true;
    }

    setAvailableCutModes() {
        const {width, height} = this.mainShapeDimensions;

        const materialData = this.materialSettings.subType ? this.materialSettings.subType : this.materialSettings.type;

        if (!materialData) {
            return;
        }

        const mainShapeTag = this.mainShape.type.name;

        for (const cutMode of this.cutModes) {
            cutMode.available = false;

            if (!materialData.cutPrices[`${cutMode.type.name}Available`]) {
                continue;
            }

            if (materialData.availableMainShapes[cutMode.type.name][mainShapeTag]) {
                cutMode.available = true;
            }
        }

        if (this.visibleElements.length > 0) {
            for (const hole of this.visibleElements) {
                const holeTypeTag = hole.shape.name;

                for (const cutMode of this.cutModes) {
                    if (!cutMode.available) continue;

                    if (!materialData.availableHoleTypes[cutMode.type.name][holeTypeTag]) {
                        cutMode.available = false;
                        console.log(`configuratorController::setAvailableCutModes -> not available hole type: ${holeTypeTag} - available:`, materialData.availableHoleTypes[cutMode.type.name]);
                    }
                }
            }
        }

        if (width > Validator.maximumChainPolishedSize.w || height > Validator.maximumChainPolishedSize.h) {
            this.cutModes[2].available = false;
        }

        console.log(`configuratorController::setAvailableCutModes -> material restrictions: laser = ${this.cutModes[1].available}, chain = ${this.cutModes[0].available}, chainPolished = ${this.cutModes[2].available}, frez = ${this.cutModes[3].available}`);

        if (this.activeCutMode.available) {
            console.log(`configuratorController::setAvailableCutModes -> leave current active ${this.activeCutMode.type.name}`);
            return true;
        }

        if (this.cutModes[0].available) {
            this.setActiveCutMode(this.cutModes[0]);
            return true;
        }

        if (this.cutModes[1].available) {
            this.setActiveCutMode(this.cutModes[1]);
            return true;
        }

        if (this.cutModes[3].available) {
            this.setActiveCutMode(this.cutModes[3]);
            return true;
        }

        if (this.cutModes[2].available) {
            this.setActiveCutMode(this.cutModes[2]);
            return true;
        }
    }

    synchronizeModel() {
        const paramsNames = ['x', 'y', 'd', 'w', 'w2', 'h', 'h2', 'r', 't', 't1', 't2', 'fontSize', 'importantSize'];

        for (const rawElement of this.CP.elements) {
            let match = this.elements.filter(element => element.rawElement === rawElement)[0];

            if (!match) {
                continue;
            }

            let elementConsoleLog = `configuratorController::synchronizeModel (Hole) ->`;

            for (const paramName of paramsNames) {
                if (!rawElement.holeElement[paramName]) continue;

                console.log('holeElement', rawElement.holeElement);

                elementConsoleLog += ` ${paramName}: ${match[paramName]} => ${rawElement.holeElement[paramName]}`;
                match[paramName] = rawElement.holeElement[paramName];
            }

            console.log(elementConsoleLog);
        }

        if (!this.CP.mainShape) return;

        const rawMainShape = this.CP.mainShape;

        let mainShapeConsoleLog = `configuratorController::synchronizeModel (${this.mainShape.type.name}) ->`;

        for (const paramName of paramsNames) {
            if (!rawMainShape[paramName]) continue;

            mainShapeConsoleLog += ` ${paramName}: ${this.mainShape[paramName]  } => ${rawMainShape[paramName] }`;
            this.mainShape[paramName] = rawMainShape[paramName];
        }

        console.log(mainShapeConsoleLog);
    }

    forceRedrawMainShape() {
        console.log('configuratorController::forceRedrawMainShape', this.mainShape);

        if (this.mainShape.rawElement) {
            this.mainShape.rawElement.destroy();
            this.mainShape.rawElement.setActiveDescription(null);
            this.mainShape.rawElement = null;
            this.mainShape.oldType = null;
        }

        const {oldType, type, rawElement, ...mainShapeParams} = this.mainShape;

        if (this.CP) {
            this.mainShape.rawElement = this.CP.ElementFactory(this.mainShape.type, mainShapeParams).drawBBox().dimensioning();
            this.CP.setMainShape(this.mainShape.rawElement);
        }

        this.mainShape.rawElement.mergePaths(false);
        //this.initComplete();
    }

    redrawMainShape() {

        if (this.mainShape.oldType && (this.mainShape.oldType != this.mainShape.type) && this.mainShape.rawElement) {
            this.mainShape.rawElement.destroy();
            this.mainShape.rawElement.setActiveDescription(null);
            this.mainShape.rawElement = null;
            this.mainShape.oldType = null;
        }

        const {oldType, type, rawElement, ...mainShapeParams} = this.mainShape;

        if (!this.mainShape.rawElement) {
            //this.mainShape.rawElement = this.CP.ElementFactory(this.mainShape.type, mainShapeParams).drawBBox().dimensioning();
            this.mainShape.rawElement = this.CP.ElementFactory(this.mainShape.type, mainShapeParams).drawBBox().dimensioning();
            this.CP.setMainShape(this.mainShape.rawElement);
        } else {
            this.mainShape.rawElement.set(mainShapeParams);
        }

        this.mainShape.rawElement.mergePaths(false);
        //this.initComplete();
    }

    redrawElements() {
        for (const element of this.elements) {
            const {type, shape, rawElement, ...elementParams} = element;

            if (element.removed && element.rawElement) {
                element.rawElement.destroy();
                continue;
            }

            if (!element.rawElement) {
                element.rawElement = this.CP.ElementFactory(element.type, this.CP.ElementFactory(element.shape, elementParams));
            } else {
                element.rawElement.set(elementParams);
            }

            element.rawElement.disableActive();
            if (this.activeElement === element) element.rawElement.setActive();
        }

        this.mainShape.rawElement.mergePaths(false);

        if(!this.hasHoles) {
            this.wantAddHoles = false;
        }
    }

    checkMaximumTextHeight(height) {

        const clonedeep = require('lodash.clonedeep');
        const {oldType, type, rawElement, ...mainShapeParams} = this.mainShape;
        const textMainShapeParams = clonedeep(mainShapeParams);
        textMainShapeParams.h = height;

        let textRawElement = this.CPText.ElementFactory(this.mainShape.type, textMainShapeParams).drawBBox().dimensioning();
        this.CPText.setMainShape(textRawElement);

        let lastBboxHeight = null;

        if (this.hasTextValidSize(textRawElement, textMainShapeParams, height)) {
            do {
                if(lastBboxHeight === textRawElement.oryginalBbox.height) {
                    height--;
                    break;
                }
                height = height + 1;
                lastBboxHeight = textRawElement.oryginalBbox.height;
            } while (this.hasTextValidSize(textRawElement, textMainShapeParams, height));

            height--;
        } else {
            do {
                height = height - 1;
            } while (!this.hasTextValidSize(textRawElement, textMainShapeParams, height));
        }

        this.maximumTextHeight = height;

        return height;
    }

    hasTextValidSize(textRawElement, textMainShapeParams, height) {

        textMainShapeParams.h = height;
        textRawElement.set(textMainShapeParams);

        const originalBbox = textRawElement.oryginalBbox;

        const bboxWidth = originalBbox ? originalBbox.width : 0;
        const bboxHeight = originalBbox ? originalBbox.height : 0;

        textRawElement.destroy();
        textRawElement.setActiveDescription(null);
        textRawElement = null;

        return bboxWidth <= this.mainShapeParam.validator.getMaximumShapeSize().w && bboxHeight <= this.mainShapeParam.validator.getMaximumShapeSize().h;
    }

    markElementsActive() {
        for (const element of this.elements) {
            element.rawElement.disableActive();
            if (this.activeElement === element) element.rawElement.setActive();
        }
    }

    calculatePriceDebounce() {
        this.calculatingPrice = true;

        if (this.calculatingPriceTimeout) {
            this.$timeout.cancel(this.calculatingPriceTimeout);
            this.calculatingPriceTimeout = null;
        }

        this.calculatingPriceTimeout = this.$timeout(
            () => {
                this.calculatePrice();
            },
            1000
        );
    }

    calculatePrice() {
        if (!this.materialSettings.size) return false;

        this.service.getPrice(this.localModel, this.quantity).then(
            response => {
                this.price = response.data.price;
                this.currency = response.data.currency;
                this.shop_id = response.data.shop_id;
                this.deliveryDate = response.data.delivery_date;
                this.calculatingPrice = false;
            },
            response => {
                console.log(`Error while calculating price!`);
            }
        );
    }

    showAddToCartModal() {
        const model = this.localModel;

        model.mainShape.name = this.translate.t(`configurator.mainShape.typeName.${model.mainShape.type.name}`);
        model.mainShape.width = this.mainShape.rawElement.oryginalBbox.width.toFixed(0);
        model.mainShape.height = this.mainShape.rawElement.oryginalBbox.height.toFixed(0);

        model.name = this.translate.t(
            'configurator.productConfiguratorName',
            {
                'mainShapeName': this.translate.t(`configurator.mainShape.type.${model.mainShape.type.name}`),
                'width': model.mainShape.width,
                'height': model.mainShape.height,
                'materialName': model.material.type.name,
                'materialSubTypeName': (model.material.subType ? ', ' + model.material.subType.name : ''),
                'materialSizeName': model.material.size.name,
                'cutModeName': this.translate.t(`configurator.cutMode.${model.cutMode}.desktop`),
                'holesCount': model.elements.length
            }
        );

        this.modalService.showModal({
            template: addToCartModalHtml,
            controller: addToCartModalController,
            controllerAs: '$ctrl',
            preClose: (modal) => {
                // Hide bootstrap modal
                modal.element.modal('hide');
            },
            inputs: {
                model: model,
                price: this.price,
                currency: this.currency,
                service: this.service,
                quantity: this.quantity,
                shop_id: this.shop_id
            }
        }).then(modal => {
            // Show bootstrap modal
            modal.element.modal({
                backdrop: 'static',
                keyboard: false
            });
            modal.closed.then(result => {
                // Redirect to cart
                if (!result) return false;
            });
        });
    }

    sanitizeElementsParams() {
        const elementParams = ['d', 'h', 'r', 'w', 'x', 'y'];
        this.elements.forEach(element => {
            elementParams.forEach(elementParam => {
                if (!element[elementParam]) {
                    return;
                }
                if (typeof element[elementParam] === 'string') {
                    element[elementParam] = parseFloat(element[elementParam].replace(',', '.'));
                }
            });
        });
    }

    /* Adding/changing elements */

    addHole(holeType) {
        const dimensions =  this.mainShapeDimensions;

        let hole = {
            type: ElementType.Hole,
            shape: holeType.shape,
            name: holeType.name,
            image: holeType.image,
            imageMobile: holeType.imageMobile,
            rawElement: null,
            x: 10,
            y: 10,
            d: 10,
            w: 10,
            h: 10,
            r: 2,
            removed: false
        };

        if (dimensions.width > 0 && dimensions.height > 0) {
            hole.d = Math.floor(Math.min(dimensions.width, dimensions.height) * 0.15);
            hole.w = Math.floor(Math.min(dimensions.width, dimensions.height) * 0.15);
            hole.h = Math.floor(Math.min(dimensions.width, dimensions.height) * 0.15);
            hole.x = Math.floor(dimensions.width / 2);
            hole.y = Math.floor(dimensions.height / 2);

            if (hole.shape !== this.MainShapeType.Circle) {
                hole.x -= Math.floor(hole.w / 2);
                hole.y -= Math.floor(hole.h / 2);
            }
        }

        this.elements.push(hole);
        this.setActiveElement(hole);
        this.wantAddHoles = false;

        if(this.isMobile) {
            this.displayHoleTooltip(holeType);
        }
    }

    displayHoleTooltip(holeType) {
        this.$mdToast.show({
            hideDelay: 4000,
            position: 'top right',
            template: ToastTemplate,
            controller: 'ToastController',
            controllerAs: 'ctrl',
            bindToController: true,
            locals: {
                toastMessage: this.translate.t(holeType.info),
                class: 'toast-configurator'
            }
        });
    }

    get materialDescription() {
        return (this.urlParts.size && this.materialSettings.size.description ? this.$sce.trustAsHtml(this.materialSettings.size.description) : false)
            || this.$sce.trustAsHtml(this.materialSettings.type.description);
    }

    get isMobile() {
        return this.$window.innerWidth <= 720;
    }

    get hasHoles() {
        return this.elements.filter(element => !element.removed).length > 0;
    }

    initComplete() {
        // Small hack to prevent displaying not ready component
        if(!this.isReady) {
            this.isReady = true;
            this.translate.promise.then(() => {
                console.log('$$ unhide');
                const loadingContainer = document.getElementsByClassName('configurator-loading')[0];
                loadingContainer.classList.add('configurator-loading-complete');
            });
        }
    }
}

let configuratorComponent = {
    bindings: {
        'h1': '@',
        'materialSlug': '<',
        'slug1': '<',
        'slug2': '<',
        'model': '@',
        'quantity': '='
    },
    template: configuratorHtml,
    controller: configuratorController
};

export default configuratorComponent;
